// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"M0-z","subtitle":"N0-z","wrapper":"O0-z","leftArrow":"P0-z","rightArrow":"Q0-z"};